import * as React from 'react';
import { routeProvide } from './routeProvide';
export var AsyncContentWrapper = function (_a) {
    var promisedContent = _a.promisedContent, resultRef = _a.resultRef;
    var result = resultRef.current;
    if (!result) {
        throw Promise.resolve(promisedContent);
    }
    else if (result.type === 'error') {
        throw result.error;
    }
    return React.createElement(React.Fragment, null, result.value);
};
export function routeAsync(asyncRouter) {
    return routeProvide(function (request, response) {
        var resultRef = {
            current: null,
        };
        // Defer this promise until we're ready to actually render the content
        // that would have existed at this page.
        var promisedContent;
        var lazyPromise = {
            then: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (!promisedContent) {
                    promisedContent = Promise.resolve(asyncRouter(request, response));
                    promisedContent
                        .then(function (value) {
                        resultRef.current = {
                            type: 'value',
                            value: value,
                        };
                    })
                        .catch(function (error) {
                        resultRef.current = {
                            type: 'error',
                            error: error,
                        };
                        response.error = error;
                        response.status = 500;
                        console.error('An async router failed with the following error:', error);
                        throw error;
                    });
                }
                return promisedContent.then.apply(promisedContent, args);
            },
        };
        response.pendingSuspenses.push(lazyPromise);
        return (React.createElement(AsyncContentWrapper, { promisedContent: lazyPromise, resultRef: resultRef }));
    });
}
